"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import type { LessonQuizItem } from "@/lib/academy/lesson-content";

interface LessonQuizProps {
  questions: LessonQuizItem[];
}

export function LessonQuiz({ questions }: LessonQuizProps) {
  const [open, setOpen] = useState<Record<number, boolean>>({});

  const toggle = (index: number) => {
    setOpen((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  if (questions.length === 0) return null;

  return (
    <div className="space-y-4">
      {questions.map((item, index) => {
        const isOpen = open[index] ?? false;
        return (
          <article
            key={`${item.question}-${index}`}
            className="rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--bg-elevated)] p-4"
          >
            <h3 className="text-sm font-medium text-[var(--fg)]">
              Q{index + 1}. {item.question}
            </h3>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => toggle(index)}
              aria-expanded={isOpen}
              className="mt-3"
            >
              {isOpen ? "Hide answer" : "Reveal answer"}
            </Button>
            {isOpen ? (
              <div className="mt-3 rounded-[var(--radius)] border border-[var(--brand-border)] bg-[var(--brand-tint)] p-4">
                <p className="text-sm font-medium text-[var(--brand)]">Answer</p>
                <p className="mt-2 text-sm leading-relaxed text-[var(--fg)]">{item.answer}</p>
                <p className="mt-3 text-sm font-medium text-[var(--fg-subtle)]">Rationale</p>
                <p className="mt-1 text-sm leading-relaxed text-[var(--fg-muted)]">
                  {item.rationale}
                </p>
              </div>
            ) : null}
          </article>
        );
      })}
    </div>
  );
}

